export default __webpack_public_path__ + "static/media/forest.e17dc647.mp3";